import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntRefreshIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.148 4.17501C6.22634 2.1116 9.57345 2.07648 11.7089 4.06262L9.66916 6.08828L14.7917 6.10145L14.5274 1.26341L12.9891 2.79209C10.1424 0.10175 5.6477 0.135116 2.86429 2.90009C1.67454 4.08106 0.987027 5.57111 0.800003 7.11208L2.62371 7.17267C2.78966 6.07511 3.29717 5.01969 4.148 4.17501ZM6.33085 9.91218L1.20832 9.899L1.47173 14.737L3.01183 13.2084C5.8567 15.8987 10.3514 15.8653 13.1366 13.1012C14.3255 11.9194 15.013 10.4293 15.2 8.88837L13.3772 8.82779C13.2112 9.92535 12.7037 10.9816 11.8529 11.8254C9.7763 13.8889 6.42919 13.924 4.29202 11.9378L6.33085 9.91218Z"
      />
    </SntIcon>
  );
};

export default SntRefreshIcon;
